import LeftImage from "../../magic_bg_page/anime-generator/LeftImage";
import RightImage from "../../magic_bg_page/anime-generator/RightImage";
import FileInput from "../FileInput/FileInput";
import MainBlock from "../MainBlock/MainBlock";
import FaqComponent from "../../FaqComponent/FaqComponent";
import TryOur from "../../erase_and_replace/TryOur";

function LandingLayoutTypeA({ dictionary, isLoading, uploadFile, checkNonAuth, landingData }) {
	return (
		<>
			{landingData.main && (
				<MainBlock dictionary={dictionary} mainBlockData={landingData.main}>
					<FileInput uploadFile={uploadFile} dictionary={dictionary} loading={isLoading} creditCost={"1_credit"} checkNonAuth={checkNonAuth} />
				</MainBlock>
			)}
			{landingData.itsDesign && <TryOur dictionary={dictionary} geEvent={"Interior Design Planner"} photos={landingData.tryOurProps.photos} clickHandler={landingData.tryOurProps.clickHandler} />}
			{landingData.left && <LeftImage dictionary={dictionary} blockData={landingData.left} />}
			{landingData.right && <RightImage dictionary={dictionary} blockData={landingData.right} />}
			{landingData.left2 && <LeftImage dictionary={dictionary} blockData={landingData.left2} />}
			{landingData.faqName && <FaqComponent ent dictionary={dictionary} pageName={landingData.faqName} isPurpleBack={true} />}
		</>
	);
}

export default LandingLayoutTypeA;
